import React from 'react';

const testIds = {
    FORWARD_ICON: 'FORWARD_ICON'
};

const ForwardIcon = (props: any) => (
    <svg
        data-test-id={testIds.FORWARD_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.51835 4.29954C9.76261 2.79998 12.4574 2.12497 15.1436 2.38953C17.2775 2.59972 19.3012 3.39258 21 4.66667H18.6667V7H23.3333C23.9777 7 24.5 6.47767 24.5 5.83333V1.16667H22.1667V2.62873C20.1773 1.20002 17.8361 0.3101 15.3722 0.0674356C12.1488 -0.250039 8.91513 0.559971 6.22202 2.35944C3.52891 4.15892 1.54306 6.83654 0.602838 9.93604C-0.337386 13.0355 -0.173811 16.3652 1.06569 19.3576C2.30519 22.3501 4.54393 24.8201 7.40046 26.3469C10.257 27.8738 13.5546 28.3629 16.7313 27.731C19.908 27.0991 22.7674 25.3853 24.8221 22.8815C26.877 20.3777 28 17.239 28 14H25.6667C25.6667 16.6992 24.7308 19.3148 23.0184 21.4012C21.3061 23.4877 18.9233 24.9159 16.276 25.4425C13.6288 25.9691 10.8808 25.5614 8.50038 24.2891C6.11995 23.0167 4.25433 20.9583 3.22141 18.4647C2.18849 15.971 2.05218 13.1963 2.8357 10.6134C3.61922 8.03045 5.27409 5.79911 7.51835 4.29954Z"
            fill="#F9FAFA"
        />
        <text
            x="50%"
            y="55%"
            dominant-baseline="middle"
            text-anchor="middle"
            font-size="11"
            font-family="Arial, sans-serif"
            fill="#F9FAFA"
        >
            10
        </text>
    </svg>
);

export {ForwardIcon};
